import { log } from '@/logger/logger';
import { addRumAction } from '@/providers/datadog';
import { track } from '@/utils/analytics';
import { TrackTypeEnum } from '@/hooks/useAnalytics';

const logger = log.getLogger('SocketHealth');

/**
 * Socket- and save-health telemetry. Socket events are sampled by `client-log-socket-events` at their call
 * sites; the save hold's reports are not sampled.
 *
 * Emitted three ways on purpose. The warn log is the queryable surface — `forwardToDatadog` drops
 * `debug`, so the existing socket logs never leave the browser. The RUM action feeds dashboards.
 * The PostHog event is what makes these joinable with `run_model_start`, which is where "was a run
 * affected" gets answered.
 */
export const reportSocketHealth = (event: string, context: Record<string, unknown>): void => {
  logger.warn(`Socket health: ${event}`, context);
  addRumAction(event, context);
  track(event, context, TrackTypeEnum.Product);
};
